'use strict';

import {Component,Inject,Input,  EventEmitter, Output} from 'ng-metadata/core';
import {TranslationService} from "../../../../../translate/translation.service";

import serviceProviders, { LocationsFilterService } from './locationsFilter.service';
//your imports go here
import {StringUtils} from '../../../../../nddUtils/stringUtils.service';
import {ConfigurationUtil} from '../../../../../nddUtils/configurationUtil.service';

const _get= require('lodash/get');

@Component({
selector: 'prm-locations-filter',
    template:'<div ng-include="$ctrl.templateUrl"></div>'
})



export class PrmLocationsFilter{
    @Input() item: Object;
    @Input() isDisabled: boolean;
    @Input() isAfterFiltering : boolean;
    @Input() public isClearAllFilters:boolean;
    @Output() filterEvent = new EventEmitter<Object>();
    @Output() clearFiltersEvent = new EventEmitter<Object>();
    private templateUrl: string;
    //@Input() locationsFilterVisible: boolean;
    @Input() public dropDownOptions: {
        locations: string[];
        years: number[];
        volumes: number[];
        descriptions: string[];
    };
    @Input() public filters = {};
    private dropdownsChanged:boolean = false;

    private _locationsFilterVisible:boolean = false;

    constructor(private locationsFilterService: LocationsFilterService,
                @Inject('opacLocations') private opacLocations,
                @Inject('$translate') private $translate :ng.translate.ITranslateService,
                @Inject('$scope') private $scope: ng.IScope,
                private stringUtils:StringUtils,
                private translationService: TranslationService,
                private configurationUtil : ConfigurationUtil) {
    }

    get changed() {
        if(this.filters){
            this.dropdownsChanged = true;
        }else{
            this.dropdownsChanged = false;
        }
        return this.dropdownsChanged;

    }

    ngOnInit(){
           this.$scope.$watch(()=>this.dropDownOptions, (newVal,oldVal)=>{
           if (!newVal || newVal=='undefined' || !angular.isDefined(newVal.locations)) {
                this.dropDownOptions = {locations:[], years:[], volumes:[], descriptions:[]};
                this.locationsFilterService.setFilterDropDownOptions(this.item,this.dropDownOptions);
            }
        });
        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            this.templateUrl =  'components/search/fullView/getit/opac/locationsFilter/alma-locations-filter.html';
        }
        else {
            this.templateUrl =  'components/search/fullView/getit/opac/locationsFilter/locations-filter.html';
        }
        this._locationsFilterVisible= true;

        /* we will set this.locationsFilterService.dropDownOptions on every ngOnInit */
        if(!this.dropDownOptions) {
            this.dropDownOptions = {locations:[], years:[], volumes:[], descriptions:[]};
            this.locationsFilterService.setFilterDropDownOptions(this.item,this.dropDownOptions);
        }


        this.$scope.$watch(()=>this.isClearAllFilters, (newVal,oldVal)=>{
            if (newVal) { //clear all dropdowns
                this.clearFilters();
            }
        });

    }

    ngOnDestroy(){
        this.locationsFilterVisible= false;
        /* caused a problem of 'undefined' in locationItems.directive in isFilter(), because this.locationsFilterService.dropDownOptions
        became undefined and nOnInit was not called yet */
        this.dropdownsChanged = false;
    }

    get locationsDropDownOptions(){
        return this.dropDownOptions.locations;
    }

    get yearDropDownOptions(){
        return this.dropDownOptions.years;
    }

    get volumeDropDownOptions(){
        return this.dropDownOptions.volumes;
    }

    get descriptionDropDownOptions(){
        return this.dropDownOptions.descriptions;
    }

    get locationsFilterVisible(){
        return this._locationsFilterVisible;
    }

    set locationsFilterVisible(value){
        this._locationsFilterVisible= value;
    }

    public onChanged() {

    }

    public throwFilterEvent(){
	    let location = _get(this,"dropDownOptions.locations",[]).length ==1?_get(this,"dropDownOptions.locations")[0].split(":")[0]:this.locationFilter;
        this.filterEvent.emit({location: location, volume: this.volumeFilter, year: this.yearFilter, description: this.descriptionFilter});
    }

    get filtersMsg() {
        let noOfFilterItems:number = (this.locationFilter?1:0) + (this.yearFilter?1:0) + (this.volumeFilter?1:0);
        let and = this.$translate.instant('nui.locations.filter.message.and');

        let placeHolders = {year:'', volume:'', location:''};

        if (this.yearFilter) {
            placeHolders['year'] = this.$translate.instant('fulldisplay.locations.yearFilter') + ' ' + this.yearFilter + (noOfFilterItems==3?',':(noOfFilterItems==2?and:''));
        }

        if (this.volumeFilter) {
            placeHolders['volume'] = this.$translate.instant('fulldisplay.locations.volumeFilter') + ' ' + this.volumeFilter + (this.locationFilter?and:'');
        }

        if (this.locationFilter) {
            placeHolders['location'] = this.$translate.instant('fulldisplay.locations.locationFilter') + ' ' + this.$translate.instant(this.locationFilter);
        }

        let label = this.$translate.instant('nui.locations.filter.message', placeHolders);

        return label;
    }

	private getLocationCode(location){
		return location.split(":",2)[0];
	}

	private getLocationName(location){
		if (location.indexOf(":")>-1 && location.indexOf(":")<location.length-1)
			return location.split(":",2)[1];
		else
			return this.$translate.instant(location);
    }
    
    private getFilterName(filterOption){
        return this.translationService.translateInstantWithDefault(filterOption, filterOption);
    }
    private getFilterNameForVolume(filterOption) {
        if (!filterOption.includes('c.uresolver')) {
        	return filterOption;
    	}
    	return this.translationService.translateInstantWithDefault(filterOption, filterOption);
    }

    clearFilters(){
        this.filters = {};
        this.dropDownOptions = {locations:[], years:[], volumes:[], descriptions:[]};
        this.locationsFilterService.setFilterDropDownOptions(this.item,this.dropDownOptions);
        this.clearFiltersEvent.emit(null);
    }

    get locationFilter(){
        return this.filters.location;
    }

    set locationFilter(val){
        this.filters.location= val;
    }

    get volumeFilter(){
        return this.filters.volume;
    }

    set volumeFilter(val){
        this.filters.volume= val;
    }

    get yearFilter(){
        return this.filters.year;
    }

    set yearFilter(val){
        this.filters.year= val;
    }

    get descriptionFilter(){
        return this.filters.description;
    }

    set descriptionFilter(val){
        this.filters.description= val;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locationsFilter/locationsFilter.directive.ts